var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3339 10.875V7.25C19.3339 4.58062 17.1699 2.41666 14.5005 2.41666C11.8312 2.41666 9.66719 4.58062 9.66719 7.25V10.875M4.34086 12.5086L3.61586 20.242C3.40973 22.4408 3.30666 23.5402 3.6715 24.3893C3.99201 25.1353 4.55367 25.7521 5.26647 26.1408C6.07787 26.5833 7.1821 26.5833 9.39054 26.5833H19.6105C21.819 26.5833 22.9232 26.5833 23.7346 26.1408C24.4474 25.7521 25.009 25.1353 25.3296 24.3893C25.6944 23.5402 25.5913 22.4408 25.3852 20.242L24.6602 12.5086C24.4861 10.6519 24.3991 9.7235 23.9815 9.02161C23.6138 8.40345 23.0704 7.90867 22.4206 7.60023C21.6828 7.25 20.7504 7.25 18.8855 7.25L10.1155 7.25C8.25065 7.25 7.31821 7.25 6.58041 7.60022C5.93062 7.90867 5.38729 8.40345 5.01953 9.02161C4.60197 9.7235 4.51494 10.6519 4.34086 12.5086Z",
    stroke: "#E83E8C",
    strokeWidth: 2.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag02);
export default __webpack_public_path__ + "static/media/shopping-bag-02.0f3b8f62be72b0e1ae95417b4c0fe196.svg";
export { ForwardRef as ReactComponent };